import type { FC } from "react";
import { Grid } from "@material-ui/core";
import { EProductClassification } from "../../../api/Types";
import { QuoteLineItem } from "../../../api/Quote/QuoteLineItem";
import { Quote } from "../../../api/Quote/Quote";
import QuoteAddonWizardAddons from "./QuoteAddonWizardAddons";
import { ProductSubscription } from "../../../api/Product/ProductSubscriptionApi";
import QuoteAddonWizardSubscriptions from "./QuoteAddonWizardSubscriptions";
import { hasAddons } from "../../../app/utils";
import { ScheduleCategory } from "../../../app/consts";
import { QuoteAddonWizardSchedule } from "./QuoteAddonWizardSchedule";
import { EventSlot } from "../../../api/EventSlot/EventSlot";

interface Props {
  quote: Quote;
  category: string;
  step: number;
  activeStep: number;
  subscriptions: ProductSubscription[] | null;
  onAddAddon: (addon: QuoteLineItem) => void;
  onInfoDialogOpen: (addon: QuoteLineItem) => void;
  onChangeQuantity: (addon: QuoteLineItem, quantity: number) => void;
  onAddSubscription: (subscription: ProductSubscription) => void;
  eventSlots: EventSlot[] | null;
  onLockEventSlot: (eventSlot: EventSlot) => Promise<boolean>;
  selectedEventSlot: EventSlot | null;
  onNext: () => void;
}

const QuoteAddonWizardCategory: FC<Props> = ({
  quote,
  activeStep,
  step,
  category,
  subscriptions,
  onAddAddon,
  onInfoDialogOpen,
  onChangeQuantity,
  onAddSubscription,
  eventSlots,
  onLockEventSlot,
  selectedEventSlot,
  onNext
}) => {
  if (activeStep !== step) {
    return null;
  }

  if (category === EProductClassification.Maintenance) {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <QuoteAddonWizardSubscriptions
            quote={quote}
            subscriptions={subscriptions}
            onAddSubscription={onAddSubscription}
          />
        </Grid>
      </Grid>
    );
  }

  if (category === ScheduleCategory) {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <QuoteAddonWizardSchedule
            quote={quote}
            eventSlots={eventSlots}
            onLockEventSlot={onLockEventSlot}
            selectedEventSlot={selectedEventSlot}
            onNext={onNext}
          />
        </Grid>
      </Grid>
    );
  }

  if (!hasAddons(quote.addons)) {
    return null;
  }

  const addons = quote.addons!.filter((v) => v.classification === category);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <QuoteAddonWizardAddons
          addons={addons}
          onAddAddon={onAddAddon}
          onInfoDialogOpen={onInfoDialogOpen}
          onChangeQuantity={onChangeQuantity}
        />
      </Grid>
    </Grid>
  );
};

export default QuoteAddonWizardCategory;
